import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

interface AuthCheck {
  authenticated: boolean;
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data, isLoading } = useQuery({
    queryKey: ['auth', 'check'],
    queryFn: () => api<AuthCheck>('/api/auth/check'),
    retry: false,
  });

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#64748b',
        }}
      >
        Loading...
      </div>
    );
  }

  if (!data?.authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
